import * as React from "react";
import HoverForHelp from "components/common/HoverForHelp";
const SharingDisabledPopover = ({ type, description = void 0 }) => {
  const getReadableType = (_type) => _type.replaceAll("_", " ");
  return /* @__PURE__ */ React.createElement(HoverForHelp, { title: "Sharing not possible", pullRight: false }, description || `Only owners of this ${getReadableType(type)} are allowed to share it.`);
};
export default SharingDisabledPopover;
